export default class SCard {
  constructor (el) {
    this.el = el
    this.textContainer = this.el.querySelector('.js-s-card-text-container')
    this.text = this.el.querySelector('.js-s-card-text')
    this.openBtn = this.el.querySelector('.js-s-card-open')
    this.closeBtn = this.el.querySelector('.js-s-card-close')
    this.slide = this.el.closest('.swiper-slide')
  }

  init () {
    if (!this.text.textContent) {
      this.el.classList.add('hide-buttons')
      return;
    }
    this.initEvents()
  }

  initEvents () {
    this.openBtn.addEventListener('click', e => {
      e.preventDefault()
      this.open()
    })
    this.closeBtn.addEventListener('click', e => {
      e.preventDefault()
      this.close()
    })
    $(document).on('click', e => this.onClickOut(e))
    window.addEventListener('resize', e => this.onResize())
  }

  onResize () {
    if (this.el.classList.contains('open')) {
      this.close()
    }
  }

  setSlideHeight () {
    const fz = window.getComputedStyle(document.body).getPropertyValue("font-size").replace('px', '')
    this.slide.style.height = this.slide.clientHeight / fz + 'em'
  }

  unsetSlideHeight () {
    this.slide.style.height = 'auto'
  }

  open () {
    this.setSlideHeight()
    this.el.classList.add('open')
    $(this.text).slideDown(300)
  }
  
  close () {
    $(this.text).slideUp(300).promise().done(() => {
      this.el.classList.remove('open')
      this.unsetSlideHeight()
    })
  }

  onClickOut (e) {
    const $target = $(e.target)
    if ( !$(this.el).is(e.target) && $(this.el).has(e.target).length === 0 ) {
      this.close()
    }
  }
}